module.exports = __webpack_public_path__ + "static/media/video-section-img.2c6f376c.png";